import { render, staticRenderFns } from "./OutOfAreaDetail.vue?vue&type=template&id=6e4cd914&"
import script from "./OutOfAreaDetail.vue?vue&type=script&lang=js&"
export * from "./OutOfAreaDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutOfAreaDetail.vue?vue&type=style&index=0&id=6e4cd914&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports